import { MiddlewareStore } from "store/createStore";
import { sendMessage } from "store/messages/messages.actions";

const findPluginIframe = (source: MessageEvent["source"]) => {

    const iframes = document.getElementsByTagName('iframe');
    for (let i = 0; i < iframes.length; i++) {
        if ((iframes[i] as HTMLIFrameElement).contentWindow === source)
            return iframes[i] as HTMLIFrameElement;
    }
    return;
};

const listenToIframeMessages = (store: MiddlewareStore) => {
    window.addEventListener('message', (message: MessageEvent) => {
        if (!message.data || message.data.type !== 'smartagent') return;
        const iframe = findPluginIframe(message.source);

        if (!iframe) return;

        switch (message.data.event) {
            case 'init':
                iframe.style.height = message.data.message.height + 'px';

                iframe.contentWindow!.postMessage(
                    {
                        type: 'smartagent',
                        event: 'init',
                        message: store.getState()
                    },
                    iframe.src
                );
                return;
            case 'pulse':
                iframe.style.height = message.data.message.height + 'px';
                return;
            case 'send-message':
                store.dispatch<any>(
                    sendMessage(message.data.message)
                )
                return;

            default:
                return;
        }


    })
}

export default listenToIframeMessages;
